import Sidebar from "../../components/Sidebar";
import { Line, Bar } from 'react-chartjs-2';
import { Box, Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);

const DeliveryDashboard = () => {
  const navigate = useNavigate();
  const user = useAuth();

  const deliveryData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Completed Deliveries',
        data: [30, 40, 25, 60, 70, 50],
        fill: false,
        borderColor: '#42A5F5',
        backgroundColor: '#42A5F5',
        tension: 0.4,
      },
    ]};
  const fuelData = {
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
    datasets: [
      {
        label: 'Fuel Consumption (liters)',
        data: [150, 180, 130, 170],
        backgroundColor: '#FF7043',
      },
    ],
  };

  return (
    <>
      <Sidebar />
      <Box className="p-3 min-h-screen dark:bg-gray-900 bg-gray-100" sx={{ marginLeft: { xs: 0, md: '240px' } }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Manage Deliveries
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  startIcon={<i className="fas fa-truck" />} 
                  sx={{ mt: 2, borderRadius: '8px' }}
                  href="/dashboard/deliveries"
                  className="mt-4 bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-700 dark:hover:bg-blue-800"
                >
                  View Deliveries
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Completed Deliveries Overview */}
          <Grid item xs={12} md={6}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Completed Deliveries
                </Typography>
                <Line
                  data={deliveryData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: true,
                        position: 'top',
                        labels: {
                          color: 'grey',
                        },
                      },
                    },
                    scales: {
                      x: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                      y: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                    },
                  }}
                  className="mt-4"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Fuel Consumption Chart */}
          <Grid item xs={12} md={6}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Fuel Consumption
                </Typography>
                <Bar
                  data={fuelData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: true,
                        position: 'top',
                        labels: {
                          color: 'grey',
                        },
                      },
                    },
                    scales: {
                      x: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                      y: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                    },
                  }}
                  className="mt-4"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Button to Navigate to Route Overview */}
          <Grid item xs={12}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Route Performance
                </Typography>
                <Button 
                  variant="contained" 
                  color="secondary" 
                  startIcon={<i className="fas fa-map-marked-alt" />} 
                  sx={{ mt: 2, borderRadius: '8px' }}
                  href="/dashboard/routes"
                  className="mt-4 bg-green-500 hover:bg-green-600 text-white dark:bg-green-700 dark:hover:bg-green-800"
                >
                  View Routes
                </Button>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Box>
    </>
  );
};

export default DeliveryDashboard;
